<ng-container [ngSwitch]="orderStatus">
    <i class="approved far fa-check-square" *ngSwitchCase="orderStautsEnum.APPROVED"></i>
    <i class="rejected far fa-times-square" *ngSwitchCase="orderStautsEnum.REJECTED"></i>
    <i class="sap_canceled fas fa-backspace fa-rotate-180"
    *ngSwitchCase="orderStautsEnum.CANCELED"></i>
    <i class="sap_manual far fa-hand-paper" *ngSwitchCase="orderStautsEnum.MANUAL"></i>
    <i class="anomaly far fa-exclamation-triangle" *ngSwitchCase="orderStautsEnum.ANOMALY"></i>
    <i class="pending fal fa-pen-fancy" *ngSwitchCase="orderStautsEnum.PENDING"></i>
    <i class="far fa-question-circle" *ngSwitchDefault></i>
</ng-container>